import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  goLiveContainer: {
    height: '100vh',
    maxHeight: '100vh',
    width: '100vw',
    zIndex: 10,
    background: '#000'
  },
  liveBorderWrapper: {
    position: 'fixed',
    zIndex: 10,
    top: 0,
    left: '50%',
    transform: 'translate(-50%)'
  },
  liveBorder: {
    width: '100%',
    paddingTop: 'calc(56.25% - 6px)',
    borderWidth: '0px',
    borderStyle: 'solid',
    borderColor: 'red',
    pointerEvents: 'none',
    transition: theme.transitions.create('border-width', {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut
    }),
    zIndex: 3
  },
  liveBorderActive: {
    borderWidth: 6
  },
  goLiveButton: {
    // margin: theme.spacing(3, 0, 2),
    color: 'white',
    background: ['red', '!important'],
    minWidth: 155
  },
  bottomButtons: {
    bottom: 0,
    width: '100vw',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'column'
  },
  topSection: {
    position: 'absolute',
    top: 16,
    left: 16,
    zIndex: 100,
    alignItems: 'center',
    padding: 10,
    borderRadius: 4,
    background: 'rgba(255, 255, 255, 0.3)',
    marginRight: '16px'
  },
  greenDot: {
    background: '#76E50A',
    minWidth: 20,
    maxWidth: 20,
    minHeight: 20,
    maxHeight: 20,
    borderRadius: '50%',
    marginRight: 8
  },
  greyDot: {
    background: 'grey',
    minWidth: 20,
    maxWidth: 20,
    minHeight: 20,
    maxHeight: 20,
    borderRadius: '50%',
    marginRight: 8
  },
  eventTitle: {
    lineHeight: '1rem',
    color: 'white',
    alignSelf: 'center',
    paddingTop: '8px',
    paddingBottom: '8px',
    backgroundColor: 'rgba(0,0,0,0.2)',
    width: '100%',
    textAlign: 'center',
    fontWeight: 'normal',
    fontSize: '1rem'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Stream/styles.js